import { Pipe, PipeTransform } from '@angular/core';
import { TravelItemMinimal } from '../../api/models';

@Pipe({
  name: 'travelStatus',
})
export class TravelStatusPipe implements PipeTransform {
  transform(travel: TravelItemMinimal): 'future' | 'ongoing' | 'past' | null {
    const now = new Date();

    // Se manca la data di partenza (nessun badge)
    if (!travel?.from_date) return 'future';

    const start = new Date(travel.from_date);

    // Se manca la data di ritorno
    if (!travel.to_date) {
      if (now < start) return 'future';
      return 'ongoing'; // oggi è dopo la partenza(ongoing)
    }

    // Se entrambe le date ci sono
    const end = new Date(travel.to_date);

    if (now < start) return 'future';
    if (now >= start && now <= end) return 'ongoing';
    return 'past';
  }
}
